import { useMediaQuery } from '@mui/material'
import { type ThemeOptionVariant } from '../augmentation'
import { breakpoints } from '../breakpoints'

declare global {
  interface Window {
    // TODO: fix leaning on Cypress in shared code
    // reason: this setup is taken from @dhl/theme to have it as close to how most consumers define mobile currently
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Cypress: any
  }
}

/**
 * We can auto detect the theme to be used when none given or set to automatic
 *
 * @important only exported for our connector, should not directly be used in any other usecase!
 */
export const useAutoDetectThemeVariant = (variant?: ThemeOptionVariant | 'automatic') => {
  const mobileQuery = breakpoints.down('md')

  const isCypress = typeof window !== 'undefined' ? !!window.Cypress : false

  // TODO: not ready for SSR, so we really need this mediaquery or can it be solved differently
  const isMobile = useMediaQuery(`${mobileQuery}${!isCypress ? ', (max-width: 1024px) and (pointer: fine)' : ''}`, {
    noSsr: true,
  })

  if (variant && variant !== 'automatic') {
    return variant
  }

  // at moment no real difference between tablet/mobile nor landscape/portrait so keeping it simple for now
  return isMobile ? ('mobile' satisfies ThemeOptionVariant) : ('desktop' satisfies ThemeOptionVariant)
}
